module.exports = __webpack_public_path__ + "static/media/expand_less.01881c33.svg";